import React, { FunctionComponent, useMemo } from 'react';

export default function useCustomTracking(
  id: string,
  slot: string,
  attributes: object = {}
): [React.FunctionComponent, Function] {
  const TrackingTag = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    // eslint-disable-next-line react/display-name
    return (props = {}): any => (
      <span
        id={id}
        data-csa-c-type='element'
        data-csa-c-slot-id={slot}
        data-csa-c-content-id={id}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...attributes}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }, [id, slot, attributes]);

  const triggerClick = (): void => {
    const el = document.getElementById(id);
    if (el) {
      el.click();
    }
  };
  return [TrackingTag, triggerClick];
}
